import { createSlice } from '@reduxjs/toolkit';

const nullState = {
  _id: null,
  name: null,
  isAdmin: false,
  roles: null
};

export const userSlice = createSlice({
  name: 'user',
  initialState: nullState,
  reducers: {
    loginSuccess: (state, action) => {
      state.value = action.payload;
    },
    loginFail: (state) => {
      state.value = nullState;
    },
    logoutSuccess: (state) => {
      state.value = nullState;
    },
    setUserData: (state, action) => {
      state.value = action.payload;
    }
  }
});

export const { loginSuccess, loginFail, logoutSuccess, setUserData } = userSlice.actions;

// export const getUserId = (state) => state.user.id;
export const getUserInfo = (state) => state.user.value;

export default userSlice.reducer;
